import { r as registerInstance, h, c as createEvent, g as getElement } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import { aj as pesIconSizes, ak as pesIconMirrorDirection, d as EQdsButtonSize, c as EQdsButtonImportance } from './currency-7be6806c.js';
import './_commonjsHelpers-11ca3be1.js';

const widgetAnswersCss = "@media screen and (max-width: 979px){:host{display:block;width:100%;padding-bottom:96px}}";

const WidgetAnswers = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.answers = undefined;
    this.selectedAnswer = undefined;
  }
  render() {
    return h("pes-chips-list", { data: this.answers, selected: this.selectedAnswer });
  }
};
WidgetAnswers.style = widgetAnswersCss;

const widgetBreadcrumbsCss = ".widget-breadcrumbs{margin:0;padding:0;list-style:none;box-sizing:border-box;display:flex;flex-wrap:wrap;font-weight:400}.widget-breadcrumbs *,.widget-breadcrumbs *::before,.widget-breadcrumbs *::after{box-sizing:inherit}.widget-breadcrumbs__item{line-height:1;display:flex;align-items:center}.widget-breadcrumbs__button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;display:inline-block;font-size:14px;line-height:18px;color:#333333;text-decoration:none}.widget-breadcrumbs__button--last{color:#9fa0a4}.widget-breadcrumbs__icon{margin:0}:host([dir=\"rtl\"]) .widget-breadcrumbs__icon{transform:scaleX(-1)}";

const WidgetBreadcrumbs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBreadcrumbClick = createEvent(this, "didBreadcrumbClick", 7);
    this.handleBreadcrumbClick = (value) => () => {
      this.didBreadcrumbClick.emit(value);
    };
    this.breadcrumbs = [];
    this.isLastSelected = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("ul", { class: "widget-breadcrumbs" }, this.breadcrumbs.map((item, index) => {
      const lastIndex = this.breadcrumbs.length - 1;
      const isLast = this.isLastSelected && index === lastIndex;
      return (h("li", { class: "widget-breadcrumbs__item", key: item.name }, h("button", { class: classnames('widget-breadcrumbs__button', {
          'widget-breadcrumbs__button--last': isLast,
        }), onClick: this.handleBreadcrumbClick(item) }, h("span", { innerHTML: item.name })), !isLast && h("pes-icon", { class: "widget-breadcrumbs__icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
    })));
  }
  get el() { return getElement(this); }
};
WidgetBreadcrumbs.style = widgetBreadcrumbsCss;

const widgetRangesCss = "@media screen and (min-width: 980px){:host{flex:1;overflow:auto;scrollbar-width:thin !important}:host::-webkit-scrollbar{width:6px;height:6px}:host::-webkit-scrollbar-thumb{background:#cbcbcb;border-radius:3px}:host::-webkit-scrollbar-track{background:#ffffff;border-radius:3px}:host{scrollbar-face-color:#cbcbcb;scrollbar-track-color:#ffffff}}@media screen and (max-width: 979px){.widget-ranges{position:absolute;height:100%;width:100%;top:0;bottom:0;left:0;right:0;background-color:#ffffff}}.widget-ranges__results{margin:20px 0;font-size:14px;color:#333333;line-height:20px}.widget-ranges__results-total{font-weight:bold}.widget-ranges__button-wrapper{position:fixed;bottom:0;left:0;right:0;margin:0 8px 20px}.widget-ranges__button-wrapper::before{content:\"\";position:absolute;height:48px;width:100%;display:block;bottom:68px}:host(:not([dir=\"rtl\"])) .widget-ranges__button-wrapper::before{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}:host([dir=\"rtl\"]) .widget-ranges__button-wrapper::before{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}.widget-ranges__button{width:100%}.widget-ranges__cards{display:flex;flex-wrap:wrap;width:100%}.widget-ranges__card{width:100%}@media screen and (min-width: 980px){.widget-ranges__card{width:50%}}.widget-ranges__shadow{position:absolute;height:48px;width:100%;bottom:0}:host(:not([dir=\"rtl\"])) .widget-ranges__shadow{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);right:6px}:host([dir=\"rtl\"]) .widget-ranges__shadow{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);left:6px}";

const RANGES_COUNT_PER_ROW = 2;
const NUMBER_OF_RANGES_PLACEHOLDER = '#number of ranges#';
const WidgetRanges = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onButtonClick = () => {
      this.isResultShown = true;
    };
    this.ranges = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isMobile = undefined;
    this.isLastSelected = undefined;
    this.labels = undefined;
    this.isPBS = false;
    this.isResultShown = false;
  }
  onBackButtonClick() {
    this.isResultShown = false;
  }
  render() {
    var _a, _b, _c, _d, _e;
    const rangesTotalCount = this.ranges.length;
    if (this.isMobile && !this.isResultShown && !this.isLastSelected) {
      return (h("div", { class: "widget-ranges__button-wrapper" }, h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED, class: "widget-ranges__button", block: true, onClick: this.onButtonClick, text: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount)) })));
    }
    const { hmcViewProducts, useProductSelector, featuresLabel, bestMatchLabel, hmcViewDetails, } = this.labels || {};
    const cardLabels = {
      hmcViewProducts,
      hmcViewDetails,
      useProductSelector,
      featuresLabel,
      bestMatchLabel,
    };
    return (h("div", { class: "widget-ranges" }, this.isMobile ? ([
      h("pes-widget-back-button", { backLabel: (_b = this.labels) === null || _b === void 0 ? void 0 : _b.backLabel }),
      h("pes-widget-header", null, (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount))),
    ]) : (h("p", { class: "widget-ranges__results" }, (_e = (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcMessageWeFoundResultsDesktop) === null || _e === void 0 ? void 0 :
      _e.replace(NUMBER_OF_RANGES_PLACEHOLDER, ''), h("span", { class: "widget-ranges__results-total" }, rangesTotalCount))), h("div", { class: "widget-ranges__cards" }, this.ranges.map((range, index) => (h("pes-hmc-card", { key: range.rangeId, class: "widget-ranges__card", range: range, page: "range", isPBS: this.isPBS, isBestMatch: this.isLastSelected && index === 0, rangeTooltipInfo: this.rangeTooltipInfo, labels: cardLabels, selectorConfig: this.selectorConfig })))), !this.isMobile && this.ranges.length > RANGES_COUNT_PER_ROW && (h("div", { class: "widget-ranges__shadow" }))));
  }
};
WidgetRanges.style = widgetRangesCss;

export { WidgetAnswers as pes_widget_answers, WidgetBreadcrumbs as pes_widget_breadcrumbs, WidgetRanges as pes_widget_ranges };
